export const getTabButtonTestId = (tabValue: string, isDisabled: boolean): string =>
    `tab-${tabValue}${isDisabled ? '-disabled' : ''}`;

import { IconName } from '../Icon';
import { RestrictedWidthVariant } from '../MaxWidthRestrictedContent';

export type SideTabContentWidthVariant = 'sm' | 'md' | 'lg' | 'xl';

export type TabOption = {
    title: string;
    value: string;
    isDisabled?: boolean;
    hide?: boolean;
    renderTabContent: () => React.ReactNode;
    sideTabTitle?: string;
    sideTabContentWidthVariant?: SideTabContentWidthVariant;
    secondaryText?: string;
    icon?: IconName;
    inset?: boolean;
    heavy?: boolean;
};

export type StaticContentTabOption = Omit<TabOption, 'renderTabContent'>;

export type StaticSideTabOptionGroup = {
    title: string;
    options: StaticContentTabOption[];
};

export type StaticSideTabContent = StaticContentTabOption | StaticSideTabOptionGroup;

export const isSideTabOptionGroup = (option: StaticSideTabContent): option is StaticSideTabOptionGroup => {
    return (option as StaticSideTabOptionGroup).options !== undefined;
};

export const isSideTabOption = (option: StaticSideTabContent): option is StaticContentTabOption => {
    return !isSideTabOptionGroup(option);
};

export type BaseTabViewProps = {
    tabs: TabOption[];
    selectedTab: string;
    onChange: (value: string) => void;
    scrollable?: boolean;
    restrictedWidthVariant?: RestrictedWidthVariant;
    onlyRenderActiveTab?: boolean;
};
